var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-avatar',{attrs:{"badge":_vm.hasNotifications,"badge-top":"","variant":"light","badge-variant":"danger","icon":"bell"}})}
var staticRenderFns = []

export { render, staticRenderFns }